import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import UploadMore from '../_partials/UploadMore';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import { ShopItemType } from '../../../../../types/shop';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import ShopGrid from '../ShopGrid';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
}

const enhance = compose(withSectionFetchSpinner, withTranslation());
export class ShopPrints extends React.Component<Props> {
  render() {
    const { className } = this.props;

    return (
      <div className={s['section-with-no-header']}>
        <ShopGrid
          className={className}
          itemType={ShopItemType.PRINTS}
          uploadMore={
            <UploadMore
              itemType={ShopItemType.PRINTS}
              onCreate={() => window.location.assign(`${URLS.ROOT}/me/gallery`)}
              biData={BiData<DefaultBiEvent>({
                evid: 2,
                click_info: 'go_to_gallery',
                sectionname: 'prints',
              })}
            />
          }
        />
      </div>
    );
  }
}

export default enhance(ShopPrints) as React.ComponentType<Props>;
